import { validateFields, signupCompany, signupOperator, signupVerify, signupChangeEmail, emailChangePassword, changePassword, checkTokenOperator, checkTokenPassword } from "./signup"

export default {
  validateFields,
  signupCompany,
  signupOperator,
  signupVerify,
  signupChangeEmail,
  emailChangePassword,
  changePassword,
  checkTokenOperator,
  checkTokenPassword
}
